import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let apiUrl = `${process.env.REACT_APP_BASE_URL}test_3mintes`;

// Fetch stations, now accepting tokenStr as an argument
export const fetchTestStations = createAsyncThunk(
  "testStations/fetchTestStations",
  async (tokenStr) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const stationsSlice = createSlice({
  name: "testStations",
  initialState: {
    testLoading: true,
    testData: {
      Test: [],
    },
    testError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestStations.pending, (state) => {
        state.testLoading = true;
      })
      .addCase(fetchTestStations.fulfilled, (state, action) => {
        state.testLoading = false;
        state.testData = {
          ...state.testData,
          ...action.payload,
        };
        state.testError = "";
      })
      .addCase(fetchTestStations.rejected, (state, action) => {
        state.testLoading = false;
        state.testData = {
          Test: [],
        };
        state.testError = action.error.message;
      });
  },
});

export default stationsSlice.reducer;
